import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M13.333 7.5v8.333H6.667V7.5h6.666zm-1.25-5H7.917l-.834.833H4.167V5h11.666V3.333h-2.916l-.834-.833zM15 5.833H5v10c0 .917.75 1.667 1.667 1.667h6.666c.917 0 1.667-.75 1.667-1.667v-10z" fill="#54585D" /></svg>);